import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

/**
 * Schema de validación para el formulario de cantidad en ProductCard
 */
export const productCardQuantitySchema = z.object({
  quantity: z
    .number()
    .min(0, "La cantidad debe ser mayor o igual a 0")
    .max(10000, "La cantidad no puede exceder 10000")
    .int("La cantidad debe ser un número entero"),
});

/**
 * Tipo inferido del schema para TypeScript
 */
export type ProductCardQuantityForm = z.infer<typeof productCardQuantitySchema>;

/**
 * Valores por defecto del formulario
 */
export const defaultProductCardQuantityValues: ProductCardQuantityForm = {
  quantity: 0,
};

/**
 * Configuración de validación para React Hook Form
 */
export const productCardQuantityResolver = {
  resolver: zodResolver(productCardQuantitySchema),
  defaultValues: defaultProductCardQuantityValues,
  mode: "onChange" as const,
};
